const footerNavBar = {
  'footerNavBar-1': '© Pandito GmbH CH-270.4.008.394-2',
  'footerNavBar-2': '+41 77 409 1740 panditoicecream@gmail.com',
  'footerNavBar-3': 'Schaffhauserrheinweg 118, Basel. Öffnungszeiten',
  'footerNavBar-3-tooltip-1': 'Glacé-Ape',
  'footerNavBar-3-tooltip-2': 'Freitag bis Sonntag: 12:30–18:00',
  'footerNavBar-4': 'Im Westfeld 4, Basel. Öffnungszeiten',
  'footerNavBar-4-tooltip-1': 'Gelateria',
  'footerNavBar-4-tooltip-2': 'Montag: Geschlossen',
  'footerNavBar-4-tooltip-3': 'Dienstag: Geschlossen',
  'footerNavBar-4-tooltip-4': 'Mittwoch und Donnerstag 12:00–18:30',
  'footerNavBar-4-tooltip-5': 'Freitag 12:00–19:00',
  'footerNavBar-4-tooltip-6': 'Samstag 11:00–19:00',
  'footerNavBar-4-tooltip-7': 'Sonntag 11:00–18:30',
  'footerNavBar-5': 'Impressum / ',
  'footerNavBar-6': 'Datenschutz',
  'footerNavBar-7': 'Entworfen von Fede'
};

export default footerNavBar;
